import { ILogMessageParams } from '@shared/logger/i_log_message_params';
import { BuilderLogEntryTerminalClient } from './builder_log_entry_terminal_client';
import { ELoggerNamespaceShared } from '@shared/logger/e_logger_namespace_shared';
import { LogEntryError } from '@shared/logger/log_entry_error';
import { assert_equal } from '@shared/asserts/utils_asserts';
import { ServiceLoggerBase } from '@shared/logger/service_logger_base';

export class ServiceLoggerTerminalClient extends ServiceLoggerBase {
  protected log_info_internal(message: string, params: ILogMessageParams) {
    let log_entry = BuilderLogEntryTerminalClient.build(message, params);

    let pattern = log_entry.get_log_line_pattern();
    let styles = log_entry.get_styles_for_pattern();

    console.info(pattern, ...styles);
  }

  protected log_warning_internal(message: string, params: ILogMessageParams) {
    let log_entry = BuilderLogEntryTerminalClient.build(message, params);

    console.warn(log_entry.get_log_line());
  }

  protected log_error_internal(log_entry: LogEntryError, params: ILogMessageParams) {
    assert_equal(log_entry.content.length, log_entry.styles.length);

    let pattern = log_entry.get_message_pattern();

    let styles = log_entry.styles.map(style => (style ? `color: ${style}` : ''));

    console.log(pattern, ...styles);
  }
}
